import React, { useMemo, createRef, useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import Slider from 'react-slick';
import { NextArrow, PrevArrow } from '../../../components/molecules/CustomArrows';
import PDFImagePlaceholder from '../../../../assets/images/PDFImagePlaceholder.jpg'
import { settingsInner } from '../../../containers/common/DualHeroSlider/config';
import useStyles from './style';
import AdCarouselItem from './AdCarouselItem';
import { useTheme } from '@material-ui/core/styles';
import { canUseDOM } from '../../../utils/canUseDOM';
import { get } from 'lodash';

const AdCalendarCarouselType2 = React.memo((props) => {
  const { result, language, numberingColor } = props;
  const sliderRef = useRef()
  const [isMobile, setIsMobile] = useState('');
  const isEventsHeroSlider = true;
  const classes = useStyles();
  const className = props.className;
  const lastIdx = result ? result.length - 1 : 0;
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';

  useEffect(() => {
    if (canUseDOM) {
      const setIsMobileFunc = () => {
        setIsMobile(window.innerWidth < 1024 ? 'mobile' : 'desktop');
      }
      setIsMobileFunc();

      window.addEventListener('resize', () => {
        setIsMobileFunc()
      });
    }
    if (isRTL) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(sliderRef.current.props.children.length);
      }, 2000);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('resize');
      }
    }

  }, []);

  const sliderSettings = {
    centerPadding: '100px',
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: true,
    // swipeToSlide: true,
    speed: 400,
    easing: "ease-out",
    swipe: true,
    // rtl: isRTL,
    rtl: false,
    initialSlide: 0,
    nextArrow: <NextArrow colorVariant={'whiteVariant'} />,
    prevArrow: <PrevArrow colorVariant={'whiteVariant'} />,

    responsive: [
      {
        breakpoint: 1090,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const carousel = () => {
    if (isMobile === 'mobile' || isMobile === '') {
      return (
        <div className={'is-mobile'}>
          {
            result && result.map((item, y) => (
              <React.Fragment key={y}>
                <AdCarouselItem
                  key={y}
                  index={y}
                  item={item}
                  className={'ad-slide'}
                  isEventsHeroSlider={isEventsHeroSlider}
                  startDate={get(item, 'startDate', '')}
                  endDate={get(item, 'endDate', '')}
                  language={language}
                  numberingColor={numberingColor}
                />
              </React.Fragment>
            ))
          }
        </div>
      )
    } else if (isMobile === 'desktop') {
      return (
        <div className={'is-desktop'}>
          {/* Note: showing this slider in mobile will break UI class build on server for some unkown reason. */}
          <Slider
            ref={sliderRef}
            {...sliderSettings}
          >
            {result && result.map((item, y) => (
              <React.Fragment key={y}>
                <AdCarouselItem
                  key={y}
                  index={y}
                  item={item}
                  className={'ad-slide'}
                  startDate={get(item, 'startDate', '')}
                  endDate={get(item, 'endDate', '')}
                  language={language}
                  numberingColor={numberingColor}
                />
              </React.Fragment>
            ))}
          </Slider>
        </div>
      )
    } else return <></>
  };



  return (
    <div className={clsx(classes.AdCalendarCarouselType2, className)}>
      {carousel()}
    </div>
  )
});

export default AdCalendarCarouselType2;
